import RiskScore from 'src/assets/Personalize_List_Images/RiskScore.svg'
import ReferClaim from 'src/assets/Personalize_List_Images/ReferClaim.svg'
// import LifeEvents from 'src/assets/Personalize_List_Images/LifeEvents.svg';
// import Garage from 'src/assets/Personalize_List_Images/Garage.svg';
import HealthCampBg from 'src/assets/ComingEvents/HealthCampBg.png'
import HealthCampDetails from 'src/assets/ComingEvents/HealthCampDetails.png'
import GreenOfficeCampBg from 'src/assets/ComingEvents/GreenOfficeCampBg.png'
import ReportDownload from 'src/assets/images/ReportDownload.svg'

const PERSONALIZE_LIST_TYPE = {
  referClaim: 'REFER_CLAIM',
  riskScore: 'RISK_SCORE',
  lifeEvents: 'LIFE_EVENTS',
  garage: 'GARAGE',
  reportDownload: 'REPORT_DOWNLOAD',
}

const PERSONALIZE_LIST = [
  {
    label: 'Download Risk Report',
    description: 'Download your report',
    logo: ReportDownload,
    type: PERSONALIZE_LIST_TYPE.reportDownload,
  },
  {
    label: 'Refer A Claim',
    description: 'Even if you buy elsewhere',
    logo: ReferClaim,
    type: PERSONALIZE_LIST_TYPE.referClaim,
  },
  {
    label: 'Risk Score',
    description: 'Trovity Risk Analysis Report Score',
    logo: RiskScore,
    type: PERSONALIZE_LIST_TYPE.riskScore,
  },
  // {
  //   label: 'Update Life Events',
  //   description: 'It helps in assessing your risks more accurately',
  //   logo: LifeEvents,
  //   type: PERSONALIZE_LIST_TYPE.lifeEvents,
  // },
  // {
  //   label: 'Manage your Garage',
  //   description: 'Save your vehicle details',
  //   logo: Garage,
  //   type: PERSONALIZE_LIST_TYPE.garage,
  // },
]

const COMING_EVENTS_LIST = [
  {
    id: 10001,
    bgUrl: HealthCampBg,
    detailsUrl: HealthCampDetails,
    label: 'Health Camp',
    labelColor: '#000000',
    conductedOn: '12-12-2023',
    secondaryColor: '#000000',
    formHeading: 'Register for Health Camp',
  },
  {
    id: 10002,
    bgUrl: GreenOfficeCampBg,
    detailsUrl: HealthCampDetails,
    label: 'Green Office Camp',
    labelColor: '#9EFF22',
    conductedOn: '12-24-2023',
    secondaryColor: '#ffffff',
    formHeading: 'Register for Green Office Camp',
  },
]

const EVENT_DETAILS_VALIDATIONS = {
  phoneValidation: 'Please enter the valid phone number',
  emailValidation: 'Please enter the valid email ',
  nameRequired: 'Name is required',
  phoneRequired: 'Phone is required',
  emailRequired: 'Email is required',
  empIdRequired: 'Emp Id is required',
}

export {
  PERSONALIZE_LIST,
  PERSONALIZE_LIST_TYPE,
  COMING_EVENTS_LIST,
  EVENT_DETAILS_VALIDATIONS,
}
